interface SecurityCardProps {
  title: string;
  statusLeft: string;
  statusRight: string;
}

export function SecurityCard({
  title,
  statusLeft,
  statusRight,
}: SecurityCardProps) {
  return (
    <div
      style={{
        display: 'flex',
        width: 'min(380px, 90vw)',
        padding: '16px 22px',
        alignItems: 'center',
        gap: '11.5px',
        borderRadius: '999px',
        border: '1px solid rgba(88, 130, 255, 0.22)',
        background:
          'linear-gradient(180deg, rgba(17, 31, 66, 0.96) 0%, rgba(11, 22, 48, 0.94) 100%)',
        boxShadow:
          '0 12px 28px 0 rgba(0, 0, 0, 0.34), 0 0 24px 0 rgba(54, 106, 255, 0.10), 0 0 42px 0 rgba(80, 116, 255, 0.08), 0 1px 0 1px rgba(255, 255, 255, 0.04) inset, 0 0 24px 1px rgba(88, 112, 255, 0.06) inset, 0 -10px 20px 1px rgba(0, 0, 0, 0.18) inset',
        backdropFilter: 'blur(6px)',
      }}
    >
      {/* Status dot */}
      <div
        style={{
          width: '12px',
          height: '12px',
          flexShrink: 0,
          borderRadius: '6px',
          background:
            'radial-gradient(70.71% 70.71% at 50% 50%, #B8E2FF 0%, #74BDFF 58%, #3E7CFF 100%)',
          boxShadow:
            '0 0 12px 0 rgba(117, 191, 255, 0.75), 0 0 24px 0 rgba(62, 124, 255, 0.28)',
        }}
      />

      {/* Title */}
      <span
        style={{
          color: '#EEF5FF',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
          letterSpacing: '-0.1px',
        }}
      >
        {title}
      </span>

      {/* Status */}
      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
        }}
      >
        <span
          style={{
            color: '#66B5FF',
            fontFamily: '"JetBrains Mono"',
            fontSize: '13px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: '0.2px',
          }}
        >
          {statusLeft}
        </span>
        <span
          style={{
            opacity: 0.96,
            color: '#8EA2D9',
            fontFamily: '"JetBrains Mono"',
            fontSize: '13px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: '0.2px',
          }}
        >
          {' = '}
        </span>
        <span
          style={{
            opacity: 0.96,
            color: '#BBA2FF',
            fontFamily: '"JetBrains Mono"',
            fontSize: '13px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: '0.2px',
          }}
        >
          {statusRight}
        </span>
      </div>
    </div>
  );
}
